import { AppRouteRecordRaw } from '../types';

const Error400 = () => import('@/pages/error/error400.vue');
const Error401 = () => import('@/pages/error/error401.vue');
const Error403 = () => import('@/pages/error/error403.vue');
const Error404 = () => import('@/pages/error/error404.vue');
const Error500 = () => import('@/pages/error/error500.vue');
const Error503 = () => import('@/pages/error/error503.vue');

export const errorRoutes: AppRouteRecordRaw[] = [
  {
    path: '/error-400',
    name: 'Error400',
    component: Error400,
    meta: {
      title: 'Error400 | ryd Portal',
    },
  },
  {
    path: '/error-401',
    name: 'Error401',
    component: Error401,
    meta: {
      title: 'Error401 | ryd Portal',
    },
  },
  {
    path: '/error-403',
    alias: '/unauthorized',
    name: 'Error403',
    component: Error403,
    meta: {
      title: 'Error403 | ryd Portal',
    },
  },
  {
    path: '/error-404',
    name: 'Error404',
    component: Error404,
    meta: {
      title: 'Error404 | ryd Portal',
    },
  },
  {
    path: '/error-500',
    name: 'Error500',
    component: Error500,
    meta: {
      title: 'Error500 | ryd Portal',
    },
  },
  {
    path: '/error-503',
    name: 'Error503',
    component: Error503,
    meta: {
      title: 'Error503 | ryd Portal',
    },
  },
];
